import React from 'react';
import { FormLabel, Grid, IconButton, Stack, Tooltip } from '@mui/material';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import { InstantSearchFieldAdaptor } from '@/components/SearchField';
import { OwnerAutocomplete } from '@/components/selects/OwnerSelect';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { resetFilters, setFilters } from '@/features/table/instantSearchSlice';
import { useInstantSearchOwnerFilters } from '@/hooks/useInstantSearchOwnerFilters';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useGridItemProps } from '@/components/table/filterGrid';

const RelationshipTableFilters = ({ ownerLabel, children }) => {
	const dispatch = useDispatch();
	const { pathname: slug } = useLocation();

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });
	const userId = userDetails?.userId;
	const { owners } = useInstantSearchOwnerFilters();

	const { searchGridProps, generalGridProps, clearFilterGridProps } = useGridItemProps();

	return (
		<Grid container spacing={1} sx={{ width: '100%', pb: 2 }}>
			<Grid container spacing={2} width='100%'>
				<Grid {...searchGridProps}>
					<Stack direction='column' width='100%'>
						<FormLabel>Search</FormLabel>
						<InstantSearchFieldAdaptor />
					</Stack>
				</Grid>
				<Grid {...generalGridProps}>
					<Stack direction='column' width='100%'>
						<FormLabel>{ownerLabel}</FormLabel>
						<OwnerAutocomplete includeInactive
							multiple
							userId={owners}
							disabled={!userDetails?.canViewGroup}
							isUserFixed={(user) => {
								if (user.id === userId) return owners.length === 1;
								return false;
							}}
							onChange={(value) => {
								const newIds = [value].flat();
								dispatch(
									setFilters({
										slug,
										type: 'owners',
										values: newIds.length === 0 ? [userId] : newIds,
									}),
								);
							}}
							returnValue='id'
							disableClearable={true}
						/>
					</Stack>
				</Grid>
				{children}
				<Grid {...clearFilterGridProps}>
					<Tooltip title='Clear filters'>
						<IconButton
							variant='text'
							size='small'
							color='primary'
							onClick={() => dispatch(resetFilters(slug))}
						>
							<FilterAltOffOutlinedIcon />
						</IconButton>
					</Tooltip>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default RelationshipTableFilters;
